module.exports = __webpack_public_path__ + "static/media/yourturn.f79bbdb0.png";